/** @format */
import localStorage from "local-storage";
import PersonIcon from "@mui/icons-material/Person";
import { Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { lighten, margin } from "polished";
import moment from "moment";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import Swal from "sweetalert2";
import { deleteNote } from "../../api/notesApis/deleteNote";
import { showLoadingSwal } from "../../components/loadingSwal";
import { memo } from "react";
// CustomGradientComponent.js
class CustomGradientComponent {
  init(params) {
    this.eGui = document.createElement("div");
    this.daysRemaining = params.daysRemaining;
    this.render();
  }

  getGui() {
    return this.eGui;
  }

  render() {
    const gradient =
      "linear-gradient(90deg, rgba(30,247,0,1) 0%, rgba(233,149,3,1) 48%, rgba(255,0,0,1) 100%)";
    this.eGui.style.background = gradient;
    this.eGui.style.width = "100%";
    this.eGui.style.height = "100%";
    this.eGui.style.display = "flex";
    this.eGui.style.alignItems = "center";
    this.eGui.style.justifyContent = "center";
    this.eGui.style.color = "#ffffff";
    this.eGui.style.textShadow = "1px 1px 1px rgba(0,0,0,0.5)";
    this.eGui.innerText = `(${this.daysRemaining} gün kaldı)`;
  }
}
const createColumnDefs = (openModal, handleDelete, workTypeOptions) => {
  return [
    {
      field: "actions",
      headerName: "İşlemler",
      filter: false,
      suppressMenu: true,
      cellRenderer: memo((params) => {
        const { files, title, description } = params.data;
        const shouldShowDelete =
          (files && files.length > 0) ||
          (title && title.length > 0) ||
          (description && description.length > 0); // Eğer herhangi biri doluysa, delete butonunu göster
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%", // Satır yüksekliğine göre tam yükseklik
            }}
          >
            <IconButton
              color="secondary"
              onClick={(e) => {
                e.stopPropagation();
                openModal(params.data); // Modal'ı aç ve notu gönder
              }}
            >
              <Edit sx={{ fontSize: 19 }} />
            </IconButton>
            {!shouldShowDelete && ( // Delete butonunu koşula bağlı olarak göster
              <IconButton
                color="error"
                onClick={() => handleDelete(params.data.id)} // Silme işlemini tetikle
              >
                <Delete sx={{ fontSize: 19 }} />
              </IconButton>
            )}
          </div>
        );
      }),
      maxWidth: 90,
      sortable: false,
      filter: false,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      },
    },
    {
      field: "title",
      headerName: "Başlık",
      filter: "agTextColumnFilter", // Doğru kullanım
      maxWidth: 270,
      autoHeight: true,
    },
    {
      field: "workType",
      headerName: "İş Türü",
      maxWidth: 150,
      valueFormatter: (params) => {
        const option = workTypeOptions.find((opt) => opt.id === params.value);
        return option ? option.title : params.value; // Eğer eşleşme yoksa orijinal değeri göster
      },
    },
    {
      field: "workerTitle",
      headerName: "Sorumlu Kişi",
      maxWidth: 140,
    },
    {
      field: "taxpayerTitle",
      headerName: "Mükellef Adı",
      filter: "agTextColumnFilter", // Doğru kullanım
    },
    {
      headerName: "Durum",
      field: "status",

      cellRenderer: (params) => {
        // Gelen veriye göre renk ve metin belirle
        let buttonText = "";
        let backgroundColor = "";
        let textColor = "";

        switch (params.data.status) {
          case "DONE":
            buttonText = "Yapıldı";
            backgroundColor = "#5cb85c"; // Green for success
            textColor = "#12450f";
            break;
          case "CANCELED":
            buttonText = "İptal Edildi";
            backgroundColor = "#be1614"; // Yellow for warning
            textColor = "#ffffff";
            break;
          case "POSTPONED":
            buttonText = "Ertelendi";
            backgroundColor = "#fe7b00"; // Yellow for warning
            textColor = "#ffffff";
            break;
          case "DECLARATION_READY":
            buttonText = "Beyan Hazır";
            backgroundColor = "#00a5fe"; // Yellow for warning
            textColor = "#000000";
            break;
          case "DECLARATION_APPROVED":
            buttonText = "Beyan Onaylandı";
            backgroundColor = "#0037fe"; // Yellow for warning
            textColor = "#ffffff";
            break;
          case "IN_PROGRESS":
            buttonText = "Devam Ediyor";
            backgroundColor = "#fef100d1"; // Yellow for warning
            textColor = "#000000";
            break;
          case "EXPIRED":
            buttonText = "Süresi Geçti";
            backgroundColor = "#ff00007b"; // Yellow for warning
            textColor = "#000000";
            break;
          case "NOT_DONE":
          default:
            buttonText = "Yapılmadı";
            backgroundColor = "#d9534f"; // Red for error
            textColor = "#000000";
            break;
        }

        // Buton oluştur
        return (
          <span
            style={{
              justifyContent: "center",
              backgroundColor: lighten(0.2, backgroundColor),
              color: textColor,
              padding: "6px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              width: "130px", // Tüm butonların genişliği (örneğin 200 piksel)
              "&:hover": {
                backgroundColor: "#1565c0", // Hover rengi
              },
            }}
          >
            {buttonText}
          </span>
        );
      },
      filterParams: {
        valueFormatter: function (params) {
          if (params.value === "DONE") {
            return "Yapıldı";
          } else if (params.value === "CANCELED") {
            return "İptal Edildi";
          } else if (params.value === "POSTPONED") {
            return "Ertelendi";
          } else if (params.value === "NOT_DONE") {
            return "Yapılmadı";
          } else if (params.value === "IN_PROGRESS") {
            return "Devam Ediyor";
          } else if (params.value === "DECLARATION_READY") {
            return "Beyan Hazır";
          } else if (params.value === "DECLARATION_APPROVED") {
            return "Beyan Onaylandı";
          } else if (params.value === "EXPIRED") {
            return "Süresi Geçti";
          }
          return "";
        },
      },
    },
    {
      field: "createdAt",
      headerName: "Oluşturma Tarihi",
      filter: false,
      maxWidth: 170,
      valueFormatter: (params) =>
        moment(params.value).format("DD/MM/YYYY HH:mm"),
    },
    {
      field: "updatedAt",
      headerName: "Güncelleme Tarihi",
      maxWidth: 170,
      filter: false,
      valueFormatter: (params) =>
        moment(params.value).format("DD/MM/YYYY HH:mm"),
    },
    {
      field: "expiresAt",
      headerName: "Bitiş Tarihi",
      maxWidth: 170,
      filter: false,
      valueFormatter: (params) =>
        moment(params.value).format("DD/MM/YYYY HH:mm"),
    },
    {
      field: "expiresAt",
      headerName: "Kalan Gün",
      maxWidth: 170,
      filter: false,
      valueFormatter: (params) => {
        const expirationDate = moment(params.value);
        const daysRemaining = expirationDate.diff(moment(), "days");
        return daysRemaining === 0 || daysRemaining < 0
          ? "Süre Doldu"
          : `(${daysRemaining} gün kaldı)`;
      },
      cellStyle: (params) => {
        const expirationDate = moment(params.value);
        const daysRemaining = expirationDate.diff(moment(), "days");

        // Gradient pozisyonlarını hesapla
        // maxDays: Tam yeşil olacak gün sayısı
        // midPoint: Turuncu rengin ortalanacağı gün sayısı
        const maxDays = 30;
        const midPoint = 14;
        const minDays = 0;

        let greenPos, orangePos, redPos;

        if (daysRemaining >= maxDays) {
          // 30+ gün - tamamen yeşil
          greenPos = 100;
          orangePos = 100;
          redPos = 100;
        } else if (daysRemaining <= minDays) {
          // 0 gün ve altı - tamamen kırmızı
          greenPos = 0;
          orangePos = 0;
          redPos = 0;
        } else if (daysRemaining >= midPoint) {
          // 14-30 gün arası - yeşil ağırlıklı
          const ratio = (daysRemaining - midPoint) / (maxDays - midPoint);
          greenPos = 50 + ratio * 50; // 50% - 100%
          orangePos = 30 + ratio * 30; // 30% - 60%
          redPos = 10 + ratio * 20; // 10% - 30%
        } else {
          // 0-14 gün arası - kırmızı ağırlıklı
          const ratio = daysRemaining / midPoint;
          greenPos = ratio * 50; // 0% - 50%
          orangePos = 10 + ratio * 20; // 10% - 30%
          redPos = 70 + ratio * 30; // 70% - 100%
        }

        // Dinamik gradient oluştur
        const gradient = `linear-gradient(90deg, 
          rgba(21, 156, 3, 0.781) 0%, 
          rgba(74, 206, 98, 0.812) ${greenPos}%, 
          rgba(248, 152, 35, 1) ${orangePos}%, 
          rgba(255, 0, 0, 0.577) ${redPos}%, 
          rgba(255, 0, 0, 1) 100%)`;
        return {
          background: gradient,
          color: "white",
          borderRadius: "4px",
          padding: "6px 12px",
          textShadow: "1px 1px 1px rgba(0,0,0,0.5)",
          textAlign: "center",
          fontWeight: "bold",
          display: "flex", // Flexbox kullanıyoruz
          justifyContent: "center", // Yatayda ortalama
          alignItems: "center", // Dikeyde ortalama
          height: "70%", // Yüksekliği belirliyoruz
          marginTop: "6px",
        };
      },
    },
  ];
};
export default createColumnDefs;
